import {
  SchoolQuoteFormType,
  SchoolQuoteSources
} from "features/teachers/pages/what-is-premium/analytics/consts";

import { linkToAnonymousWhatIsPremium } from "../../links";

export function linkToAnonymousWhatIsPremiumTeacher() {
  return `${linkToAnonymousWhatIsPremium()}/teacher`;
}
type Props = {
  formType?: SchoolQuoteFormType;
  source?: SchoolQuoteSources;
};

export function linkToAnonymousSchoolGetAQuoteForm({
  formType = "premium",
  source = "unset"
}: Props) {
  return `${linkToAnonymousSchoolGetAQuoteFormPrefix()}?formType=${formType}&source=${source}`;
}

export function linkToAnonymousSchoolGetAQuoteFormPrefix() {
  return `${linkToAnonymousWhatIsPremiumTeacher()}/get-a-quote`;
}

export function linkToAnonymousSuccessfulSchoolQuoteFormPrefix() {
  return `${linkToAnonymousWhatIsPremiumTeacher()}/get-a-quote/success`;
}

export function linkToAnonymousSuccessfulSchoolQuoteForm({
  formType = "premium"
}: Props) {
  return `${linkToAnonymousSuccessfulSchoolQuoteFormPrefix()}?formType=${formType}`;
}
